import './plugins/lazyload.js';
import $ from 'jquery';

import './mega-menu';
import './header';
import './carousels';
import './accordion';
import './modal';
import './table-cols-highlights';
import './table-tooltip';
import './report-timeline';
import './newsletter-signup-form';
import './content-sections-positioning';
import './case-studies';
import './marquee-carousel';
import './wrap-table-for-content';
import './blog-page';
import './inputs-customization';
import './boxzilla-position-fix';
import './share-links';
import './add-svg-colored-classes';
import './formidable-forms';


window.getAnchorLinkTargetPosition = function ($targetEl) {
    const $header = $('header.header');

    if ( !($targetEl && $targetEl.length > 0 && $header && $header.length > 0) )
        return ;

    return $targetEl.offset().top - $header.outerHeight(true) - 80;
};


function setAnchorLinksClickHandler() {
    // Smooth anchor scrolling
    $('a[href^="#"]').on('click', function (event) {
        const targetId = $(this).attr('href');
        if (targetId.length < 2) return;
        event.preventDefault();

        if (parseInt($(this).data('change-hash'))) {
            history.replaceState(null, '', `${targetId}`);
        }

        const targetElement = $(targetId);

        if (targetElement.length) {
            const targetPosition = window.getAnchorLinkTargetPosition(targetElement);

            $(document).trigger('anchorScrollStarted', {
                targetPosition: targetPosition,
                anchorLinkEl: this
            });

            $('html, body').stop().animate(
                {
                    scrollTop: targetPosition,
                },
                500
            ).promise().done(function () {
                $(document).trigger('anchorScrollFinished', {
                    targetPosition: targetPosition,
                    anchorLinkEl: this
                });
            });
        }
    });
}




    $(document).on('ready', function () {
        setAnchorLinksClickHandler();
    });



    $(document).on('toc:initialized', function () {
        setAnchorLinksClickHandler();
    });


